// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import lazySizes from 'lazysizes'
import imageUrlBuilder from '@sanity/image-url'
import sanityClient from '@sanity/client'

const client = sanityClient({
  projectId: '6usbttwh',
  dataset: 'production_new',
  useCdn: true
})

Vue.prototype.$sanityImageUrl = imageUrlBuilder(client)

lazySizes.init()

// Remove background image in case image is transparent
document.addEventListener('lazyloaded', function (e) {
  setTimeout(() => {
    e.target.parentNode.parentNode.style.background = 'unset'
  }, 100)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js